import React, {Component} from 'react';

import axios from 'axios';
import auth0Client from '../Auth';
import {withRouter} from 'react-router-dom';
import BootstrapTable from 'react-bootstrap-table-next';
import ToolkitProvider from 'react-bootstrap-table2-toolkit';
import 'react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css';
import {ToastContainer, ToastStore} from 'react-toasts';
import ClaimFormatterFunctions from '../Claims/ClaimFormatters';
import {SERVER_URL}  from '../Constants';


const columns = [
        { dataField: 'id', text: 'id', hidden:true},
        { dataField: 'lastName', text: 'Name', sort: true,formatter: ClaimFormatterFunctions.nameFormatter, classes:'text-primary', textAlign: 'left'},
        { dataField: 'status', text: 'Stage',formatter:ClaimFormatterFunctions.stageFormatter, filterable:true, sort: true, classes:'text-primary', textAlign: 'left' },
        { dataField: 'email', text: 'Email', sort: true, classes:'text-primary', textAlign: 'left'},
        { dataField: 'claimDate', text: 'Claim Date', sort: true, formatter:ClaimFormatterFunctions.formatDate,  headerStyle: (colum, colIndex) => {
        return { width: '120px', textAlign: 'center' };
        } },
  
        ];



  


class LostItemClaims extends Component {
  constructor(props) {
    super(props);

    this.state = {
        claims: [],
        

    };

    this.rowEvents = {
        onClick: (e, row, rowIndex) => {
          if (this.props.selectClaim){
            this.props.selectClaim(row.id);
            console.log('selected:' + row.id )
          }
         
      
      
        },
        
      };
      axios.interceptors.response.use(response => {
        return response;
      }, error => {
       if (error.response.status === 401) {
        ToastStore.error("error unauthorized.  Your session has expired. Please log in again");
        
       }
       return error;
      });

  }

  async componentDidMount() {
   
    //this.refreshClaims();
   
  }

  refreshClaims(){
    axios.get(`${SERVER_URL}/Claims/claimsForLostitem/` + this.props.lostItemId,{
      headers: { 'Authorization': `Bearer ${auth0Client.getIdToken()}` }
    }).then((res)=>{
      const claims  = res.data;
      if (claims){
        this.setState({
          claims: claims,
         
      });
      }
    }).catch((e)=>{

    });
  }
  
  renderToast=()=>{
    return <div>
        
        <ToastContainer position={ToastContainer.POSITION.TOP_RIGHT} lightBackground store={ToastStore}/>
    </div>
}

  
  renderGrid=()=>{
    return (

      <div>
       
       {this.renderToast()}
   

        <ToolkitProvider 
        bootstrap4
          keyField='id' 
          data={ this.props.claims } 
          columns={ columns } 
         
          
          search
          >
          {
    props => (
      <div>
       

        <BootstrapTable
          striped
          hover
          condensed
          rowEvents={this.rowEvents}
          
          { ...props.baseProps }
         
        />
      </div>
    )
  }</ToolkitProvider>

      </div>


    )

    
  }



  render() {
    return (
        <div >

            {(this.props.claims) ? this.renderGrid(): null}
        </div>
          
         
            
      
      
    )
  }
}

export default withRouter(LostItemClaims);